export default class RegistrationDocumentVM {
    documentId?: number;
    documentName?: string;
    referenceName?: string;
}